export const GET_ALL_PATIENTS = '[Patients] GET_ALL_PATIENTS';
export const CREATE_PATIENT = '[Patients] CREATE_PATIENT';
